import type { ProductKey } from "./schema";

export interface ProductDefinition {
  key: ProductKey;
  label: string;
  defaultPrice: number;
  defaultCommissionRate: number;
}

export const PRODUCTS: Record<ProductKey, ProductDefinition> = {
  power_coaching: {
    key: "power_coaching",
    label: "Power Coaching",
    defaultPrice: 1500,
    defaultCommissionRate: 0.1,
  },
  accelerateur: {
    key: "accelerateur",
    label: "Accélérateur",
    defaultPrice: 590,
    defaultCommissionRate: 0.1,
  },
};

export const PRODUCT_LIST: ProductDefinition[] = Object.values(PRODUCTS);

export const RETRACTATION_DAYS = 14;
